import React, {PureComponent} from 'react';
import {Redirect} from "react-router";
import $ from "jquery";
import {Modal} from 'react-responsive-modal';
import {padDigits, YouTubeGetID} from "../functions/utils";
import Toggle from "react-bootstrap-toggle";
import ReactTooltip from "react-tooltip";
import Switch from "react-switch";
import {SketchPicker} from "react-color";
import Alert from "react-s-alert";
import MarshallWarningComponent from "../independentComponents/marshallWarningComponent";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";
import {subscribeClock} from "../functions/api";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

const telemetryIP = process.env.REACT_APP_TELEMETRY_IP;
const messagePort = process.env.REACT_APP_MESSAGE_PORT;

const super_admin = parseInt(process.env.REACT_APP_SUPER_ADMIN_ID);
const admin = parseInt(process.env.REACT_APP_EVENT_ADMIN_ID);
const sub_admin = parseInt(process.env.REACT_APP_EVENT_SUB_ADMIN_ID);

const ptFlag = serverIP + ":" + backendPort + "/images/lang/pt.png";
const esFlag = serverIP + ":" + backendPort + "/images/lang/es.png";
const enFlag = serverIP + ":" + backendPort + "/images/lang/en.png";

class HeaderRow extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            currentLap: 0,
            countDown: "--:--:--",
            show: false,
            toggleTimer: false,
            now: new Date().getTime(),
        };

        this.handleTimeCountdown = this.handleTimeCountdown.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleCloseSession = this.handleCloseSession.bind(this);
        this.onToggleTimer = this.onToggleTimer.bind(this);
        this.toggle = this.toggle.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.startSessionTimerCommand = this.startSessionTimerCommand.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {

        subscribeClock((obj) => {
            this.setState({
                now: obj.tim,
            });
        });

        if (this.props.lengthType === "time") {
            if (this.props.startTimestamp === null) {
                this.setState({
                    countDown: this.props.t("ready").toUpperCase(),
                });
            } else {
                this.handleTimeCountdown(parseInt(this.props.startTimestamp), parseInt(this.props.eventLength));
            }
        }

        if (this.props.startTimestamp === null) {
            this.setState({
                countDown: this.props.t("ready").toUpperCase(),
            });
        }

        if ($(window).width() > 1200) {
            setTimeout(() => {
                this.toggle();
            }, 1000);
        }
    }

    componentWillUnmount() {
        clearInterval(this.x);
        subscribeClock(null);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((prevProps.startTimestamp !== this.props.startTimestamp) || (prevProps.eventLength !== this.props.eventLength)) {
            clearInterval(this.x);
            if (this.props.lengthType === "time") {
                if (this.props.startTimestamp === null) {
                    this.setState({
                        countDown: this.props.t("ready").toUpperCase(),
                    });
                } else {
                    this.handleTimeCountdown(parseInt(this.props.startTimestamp), parseInt(this.props.eventLength));
                }
            }
        }
    }

    /* HANDLERS */
    toggle() {
        this.props.toggleSidebar((toggleCarList) => {
            if (toggleCarList) {
                if ($(window).width() > 1200) {
                    // Set the width of the sidebar to 250px and the left margin of the page content to 250px
                    document.getElementById("mySidebar").style.width = "21%";
                    document.getElementById("main").style.marginLeft = "21%";
                } else {
                    // Hide clock if screen too small
                    document.getElementById("myNav").style.width = "100%";
                }
            } else {
                if ($(window).width() > 1200) {
                    // Set the width of the sidebar to 0 and the left margin of the page content to 0
                    document.getElementById("mySidebar").style.width = "0";
                    document.getElementById("main").style.marginLeft = "0";
                } else {
                    document.getElementById("myNav").style.width = "0%";
                }
            }
        });
    }

    startTimer(e) {
        e.preventDefault();
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/startSessionTimer',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.sessionID,
                startDate: Math.round(helper.state.now / 1000),
            },
            success: function () {
                helper.startSessionTimerCommand(helper.props.eventID, helper.props.sessionID);
            }, error: function (err) {
                if (err) {
                    console.log("[SESSION CHOICE] startCommand: ", err);
                }
            }
        });
    }

    startSessionTimerCommand() {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: telemetryIP + ':' + messagePort + '/command-worker-device?command=RT-ORG-SESSION-TIMER-START&eventId=' + helper.props.eventID + '&sessionId=' + helper.props.sessionID + "&userId=" + helper.props.userID,
            headers: {
                'Authorization': 'Basic ' + btoa('admin:vZ3s4T7MJfWhHD5H')
            },
            dataType: 'json',
            success: function () {
                console.log('[ORGANIZER PANEL] Successfully sent start timer request');
                helper.setState({
                    waiting: false,
                    serverResult: <div className={"alert alert-success App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("confirmed")}!</div>
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error sending session ');
                    helper.setState({
                        waiting: false,
                        serverResult: <div className={"alert alert-danger App_text"} style={{fontSize: 25}} role="alert">{helper.props.t("actionError")}!</div>
                    });
                }
            }
        });
    }

    handleTimeCountdown(start_timestamp, length) {
        // Set the date we're counting down to
        const countDownDate = new Date((start_timestamp * 1000) + (length * 1000)).getTime();
        // Update the count down every 1 second
        this.x = setInterval(() => {
            // Get todays date and time
            const now = this.state.now;

            // Find the distance between now and the count down date
            const distance = this.state.toggleTimer ? now - (start_timestamp * 1000) : countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            //var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // If the count down is finished, write some text
            if ((!this.state.toggleTimer && distance < 0) || (this.state.toggleTimer && distance >= this.props.eventLength * 1000)) {
                clearInterval(this.x);
                this.setState({
                    countDown: this.props.t("ended").toUpperCase(),
                });
                if ((this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin))) {
                    this.handleShowModal();
                }
            } else {
                this.setState({
                    countDown: (padDigits(hours, 2) + ":" + padDigits(minutes, 2) + ":" + padDigits(seconds, 2)),
                });
            }
        }, 1000);
    }

    onToggleTimer() {
        this.setState({
            toggleTimer: !this.state.toggleTimer,
        });
    }

    handleShowModal() {
        this.setState({
            show: true
        });
    }

    handleCloseModal() {
        this.setState({
            show: false
        });
    }

    handleCloseSession(e) {
        e.preventDefault();
        this.props.updateSessionStatus(true);
    }

    /* RENDER */
    render() {
        return (
            <div className={"row w3-animate-fading"}>
                <div className={"col-xs-12 row-flex"}>
                    <div className={"col-xs-1"} style={{paddingRight: 0}}>
                        <button className={"openbtn button"} style={{whiteSpace: "nowrap", width: "100%", height: "46%", marginTop: 0}} onClick={this.toggle}>
                            <i className={"fas fa-align-justify"}/> <i className={"fas fa-car"}/>
                        </button>
                        <SettingsIcon
                            isOwnTeam={this.props.isOwnTeam}
                            updateCurrentCarID={this.props.updateCurrentCarID}
                            isGuest={this.props.isGuest}
                            carID={this.props.carID}
                            updateCurrentCarDataSources={this.props.updateCurrentCarDataSources}
                            privileges={this.props.privileges}
                            userID={this.props.userID}
                            eventID={this.props.eventID}
                            updateGaugesConfig={this.props.updateGaugesConfig}
                            handleLangChange={this.props.handleLangChange}
                            t={this.props.t}
                            cookies={this.props.cookies}
                            updateYoutubeStream={this.props.updateYoutubeStream}
                        />
                    </div>
                    <div className={"col-xs-3"} style={{paddingRight: 0}}>
                        <div className={"App_widgetContainer vcenter"} style={{height: "46%"}}>
                            <span className={"App_header"}>{this.props.session}</span>
                        </div>
                        <div className={"App_widgetContainer vcenter"} style={{height: "46%", marginTop: 5}}>
                            <span className={"App_header"}>{this.props.circuit}</span>
                        </div>
                    </div>
                    <div className={"col-xs-3"} style={{paddingRight: 0}}>
                        <div className={"App_widgetContainer w3-animate-zoom"} style={{height: "100%"}}>
                            <div className={"col-xs-4 col-md-2"} style={{padding: 0, height: "100%"}}>
                                <div className={"col-xs-12 w3-animate-fading"} style={{padding: 0, height: (this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? "50%" : "100%", width: "100%"}}>
                                    <Toggle
                                        onClick={this.onToggleTimer}
                                        on={<>
                                            <i className={"fas fa-arrow-up toggleIconStyle"}/> {$(window).width() > 1200 ? <i className={"fas fa-clock toggleIconStyle"}/> : null}
                                        </>}
                                        off={<>
                                            <i className={"fas fa-arrow-down toggleIconStyle"}/> {$(window).width() > 1200 ? <i className={"fas fa-clock toggleIconStyle"}/> : null}
                                        </>}
                                        height={"100%"}
                                        width={"100%"}
                                        onstyle={"danger"}
                                        offstyle={"danger"}
                                        handlestyle={"success"}
                                        size={$(window).width() > 1200 ? "sm" : "xs"}
                                        style={{
                                            borderRadius: 5,
                                        }}
                                        active={this.state.toggleTimer}
                                    />
                                </div>
                                {(this.props.privileges.includes(super_admin) || this.props.privileges.includes(admin) || this.props.privileges.includes(sub_admin)) ? (
                                    <div className={"col-xs-12 w3-animate-fading"} style={{height: "50%", padding: 0}}>
                                        <button
                                            className={"btn btn-block openbtn button"}
                                            style={{whiteSpace: "nowrap", padding: 0, marginTop: 3, height: "90%"}}
                                            data-tip={true}
                                            data-for={"startCounter"}
                                            onClick={this.startTimer}
                                            disabled={this.props.startTimestamp !== null}
                                        >
                                            <i className={"fas fa-stopwatch"}/>
                                        </button>
                                        <ReactTooltip id={"startCounter"} type={"light"}>
                                            <span className={"toolTipStyle"}>{this.props.t("startTimerSession")}</span>
                                        </ReactTooltip>
                                    </div>
                                ) : (
                                    <div/>
                                )}
                            </div>
                            <span className={"App_raceLength vcenter"}>{this.props.lengthType === "time" ? this.state.countDown : this.state.currentLap + " of " + this.props.length}</span>
                        </div>
                    </div>
                    <div className={"col-xs-5"}>
                        <div className={"App_widgetContainer w3-animate-zoom vcenter"} style={{height: "100%"}}>
                            <MarshallWarningComponent
                                marshallPosts={this.props.marshallPosts}
                                sendFlag={null}
                                fullCourseFlags={null}
                                sessionStatus={this.props.sessionFlagStatus}
                                isSingleVehicle={true}
                                enableClick={false}
                                isFlagPanel={false}
                                hasTooltip={true}
                            />
                        </div>
                    </div>
                </div>
                <Modal open={this.state.show}
                       onClose={this.handleCloseModal}
                       center={false}
                       classNames={{modal: "small-modal"}}
                       showCloseIcon={false}
                >
                    <div className={"modal-header"}>
                        <div className={"modal-title"}>
                            <b className={"App_header"} style={{color: "#000000"}}>{this.props.t("sessionEnded")}</b>
                        </div>
                    </div>
                    <div className={"modal-body"}>
                        <p className={"App_black_text"}>{this.props.t("sessionEnded_p1")}</p>
                        <p className={"App_black_text"}>{this.props.t("sessionEnded_p2")}</p>
                    </div>
                    <div className={"modal-footer"}>
                        <button
                            onClick={this.handleCloseSession}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("yes")}
                        </button>
                        <button
                            onClick={this.handleCloseModal}
                            className={"btn App_white_text button"}
                            style={{background: "#ff0003", color: "#FFFFFF"}}
                        >{this.props.t("no")}
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

class SettingsIcon extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            redirect: false,
            speedSource: "OBD",
            youtubeStream: "",
            toggleSpeed: false,
            showSeatTime: 0,
            seatTimeLimitAlert: 0,
            gaugesConfig: [],
            platformSwitch: false,
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleSaveChanges = this.handleSaveChanges.bind(this);
        this.handleActiveSwitchChange = this.handleActiveSwitchChange.bind(this);
        this.handlePublicSwitchChange = this.handlePublicSwitchChange.bind(this);
        this.handleSeatTimeSwitchChange = this.handleSeatTimeSwitchChange.bind(this);
        this.handleSeatTimeLimitChange = this.handleSeatTimeLimitChange.bind(this);

        this.handleYoutubeChange = this.handleYoutubeChange.bind(this);
        this.handleUpdateColor = this.handleUpdateColor.bind(this);
        this.handleUpdateValue = this.handleUpdateValue.bind(this);
        this.onToggleSpeedSource = this.onToggleSpeedSource.bind(this);

        this.handleLogout = this.handleLogout.bind(this);
        this.handleSwitchPlatform = this.handleSwitchPlatform.bind(this);
    }

    /* LIFE CYCLE */
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.carID !== this.props.carID) {
            const helper = this;
            $.ajax({
                type: 'POST',
                url: serverIP + ":" + backendPort + '/dashboard/getUserSettings',
                data: {
                    eventID: helper.props.eventID,
                    carID: helper.props.carID
                },
                success: function (data) {
                    helper.setState({
                        carID: helper.props.carID,
                        isOwnTeam: helper.props.isOwnTeam,
                        speedSource: data.speed_source,
                        showSeatTime: data.show_seat_time,
                        seatTimeLimitAlert: data.seat_time_alert,
                        youtubeStream: (data.youtube_stream ? data.youtube_stream : ""),
                        gaugesConfig: data.channel_config,
                    });
                    helper.props.updateGaugesConfig(data.channel_config, data.speed_source, data.show_seat_time, data.seat_time_alert);
                }, error: function (err) {
                    if (err) {
                        console.error('Error:', err);
                    }
                }
            });
        }
    }

    /* HANDLERS */
    handleClose() {
        this.setState({show: false});
    }

    handleShow() {
        this.setState({show: true});
    }

    handleLogout(e) {
        e.preventDefault();
        const helper = this;
        $.ajax({
            type: 'GET',
            url: serverIP + ":" + backendPort + '/users/logout',
            success: function (data) {
                if (data["code"] === 200) {
                    helper.setState({
                        redirect: true
                    });
                }
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
            }
        });
    }

    handleSwitchPlatform(e) {
        this.setState({
            platformSwitch: true,
        });
    }

    handleSaveChanges() {
        // POST to server
        const helper = this;
        let temp = this.state.gaugesConfig.slice();
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/saveUserSettings',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                carID: helper.state.carID,
                speedSource: helper.state.speedSource,
                youtubeStream: (helper.state.youtubeStream && helper.state.youtubeStream.length > 0) ? helper.state.youtubeStream : null,
                showSeatTime: helper.state.showSeatTime,
                seatTimeLimitAlert: helper.state.seatTimeLimitAlert,
                gaugesConfig: JSON.stringify(helper.state.gaugesConfig),
            },
            success: function () {
                helper.props.updateCurrentCarID(helper.state.carID, helper.state.isOwnTeam, helper.state.speedSource);
                helper.props.updateGaugesConfig(temp, helper.state.speedSource, helper.state.showSeatTime, helper.state.seatTimeLimitAlert);
                helper.props.updateYoutubeStream(helper.state.carID, helper.state.youtubeStream);
                helper.handleClose();
                Alert.success('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("settingsSaved") + '</span>', {
                    position: 'top-right',
                    effect: 'genie',
                    beep: false,
                    timeout: 5000,
                    offset: 150
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                    Alert.error('<span style="font-family: \'Iceland\',serif; font-weight: bold; font-size: 20px;white-space: normal">' + helper.props.t("actionError") + '</span>', {
                        position: 'top-right',
                        effect: 'genie',
                        beep: false,
                        timeout: 5000,
                        offset: 150
                    });
                }
            }
        });
    }

    handleYoutubeChange(e) {
        this.setState({
            youtubeStream: e.target.value,
        });
    }

    onToggleSpeedSource(e) {
        let temp = this.state.speedSource;
        if (this.state.speedSource === "OBD") {
            temp = "GPS";
        } else if (this.state.speedSource === "GPS") {
            temp = "OBD";
        }
        this.setState({
            speedSource: temp,
        });
    }

    handleUpdateColor(e, index, tag, color) {
        let temp = this.state.gaugesConfig.slice();
        temp[index][tag] = color;
        this.setState({
            gaugesConfig: temp,
        });
    }

    handleUpdateValue(e, index, tag) {
        let temp = this.state.gaugesConfig.slice();
        temp[index][tag] = parseInt(e.target.value);
        this.setState({
            gaugesConfig: temp,
        });
    }

    handleActiveSwitchChange(checked, e, id) {
        let temp = this.state.gaugesConfig.slice();
        temp[parseInt(id)].active = checked ? 1 : 0;
        this.setState({
            gaugesConfig: temp,
        });
    }

    handlePublicSwitchChange(checked, e, id) {
        let temp = this.state.gaugesConfig.slice();
        temp[parseInt(id)].is_public = checked ? 1 : 0;
        this.setState({
            gaugesConfig: temp,
        });
    }

    handleSeatTimeSwitchChange(checked, e) {
        let temp = checked ? 1 : 0;
        this.setState({
            showSeatTime: temp,
        });
    }

    handleSeatTimeLimitChange(e) {
        let temp = parseInt(e.target.value);
        this.setState({
            seatTimeLimitAlert: temp,
        });
    }

    /* RENDER */
    render() {
        let youtubeStreamBorder = {borderWidth: "medium"};
        let validYoutubeStream = true;

        if (this.state.youtubeStream.length > 0) {
            if (Array.isArray(YouTubeGetID(this.state.youtubeStream))) {
                // ERROR: Invalid URL
                youtubeStreamBorder = {borderColor: "#ff000e", borderWidth: "medium"};
                validYoutubeStream = false;
            } else {
                // Valid URL
                youtubeStreamBorder = {borderColor: "#00dd09", borderWidth: "medium"};
            }
        }

        const saveButton = (
            <button onClick={this.handleSaveChanges}
                    className={"btn App_white_text button"}
                    style={{background: "#ed2126", color: "#FFFFFF"}}
                    disabled={!validYoutubeStream}
            >{this.props.t("saveChanges")}</button>
        );

        let settingsStyle = {
            fontSize: "3em",
        };

        if (this.props.isGuest || !this.props.isOwnTeam) {
            settingsStyle.color = "transparent";
            settingsStyle.disabled = true;
        } else {
            settingsStyle.color = "#eb1f24";
            settingsStyle.cursor = "pointer";
        }

        return (
            (this.state.redirect || this.state.platformSwitch ? (
                    <Redirect to={{
                        pathname: "external-redirect/" + (this.state.platformSwitch ? "platform" : "logout")
                    }}/>
                ) : (
                    <>
                        {this.props.isGuest ? null : (
                            <button className={"openbtn button"} style={{whiteSpace: "nowrap", width: "100%", height: "46%", marginTop: 5}} onClick={this.handleShow}>
                                <i className={"fas fa-cog"}/>
                            </button>
                        )}
                        <Modal open={this.state.show}
                               onClose={this.handleClose}
                               center={false}
                               classNames={{modal: "big-modal"}}
                               showCloseIcon={false}
                        >
                            <div className={"modal-header"}>
                                <div className={"modal-title"}>
                                    <span className={"App_title"} style={{color: "#000000"}}>{this.props.t("settings")}</span>
                                </div>
                            </div>
                            <div className={"modal-body"}>
                                <div className={"row row-flex"}>
                                    <div className={"col-xs-1"} style={{paddingRight: 0}}>
                                        <img
                                            alt={""}
                                            id={"pt"}
                                            className={"img-responsive App_langFlag_small"}
                                            src={ptFlag}
                                            onClick={this.props.handleLangChange}
                                        />
                                    </div>
                                    <div className={"col-xs-1"} style={{paddingRight: 0}}>
                                        <img
                                            alt={""}
                                            id={"es"}
                                            className={"img-responsive App_langFlag_small"}
                                            src={esFlag}
                                            onClick={this.props.handleLangChange}
                                        />
                                    </div>
                                    <div className={"col-xs-1"} style={{paddingRight: 0}}>
                                        <img
                                            alt={""}
                                            id={"en"}
                                            className={"img-responsive App_langFlag_small"}
                                            src={enFlag}
                                            onClick={this.props.handleLangChange}
                                        />
                                    </div>
                                    <div className={"col-md-offset-2 col-xs-3"} style={{paddingRight: 0}}>
                                        <button
                                            onClick={this.handleSwitchPlatform}
                                            className={"btn btn-block App_white_text button"}
                                            style={{background: "#ed2126", color: "#FFFFFF"}}
                                        >
                                            <span><i className={"fas fa-external-link-alt"}/></span>
                                            <span>{this.props.t("switchPlatform")}</span>
                                        </button>
                                    </div>
                                </div>

                                {this.props.carID && (this.props.privileges.includes(super_admin) || this.props.isOwnTeam === 1) ? (
                                    <>
                                        <hr/>
                                        <div className={"row row-flex"}>
                                            <div className={"col-xs-5"}>
                                                <label className={"App_black_text"}>{this.props.t("youtubeStream")}</label>
                                                <input
                                                    style={youtubeStreamBorder}
                                                    className={"form-control App_black_text"}
                                                    type={"text"}
                                                    value={this.state.youtubeStream}
                                                    placeholder={this.props.t("enterValue")}
                                                    onChange={this.handleYoutubeChange}
                                                />
                                            </div>
                                            <div className={"col-xs-4"}>
                                                <label className={"App_black_text col-xs-12"} style={{paddingLeft: 0}}>{this.props.t("speedSource")}</label>
                                                <Toggle
                                                    onClick={this.onToggleSpeedSource}
                                                    on={
                                                        <div className={"App_small_title App_white_text text-center"} style={{width: "100%"}}>
                                                            <span>OBD</span><span><i className="fas fa-car-alt toggleIconStyle"/></span>
                                                        </div>
                                                    }
                                                    off={
                                                        <div className={"App_small_title App_white_text text-center"} style={{width: "100%"}}>
                                                            <span><i className={"fas fa-satellite toggleIconStyle"}/></span><span>GPS</span>
                                                        </div>
                                                    }
                                                    height={"50%"}
                                                    width={"50%"}
                                                    onstyle={"danger"}
                                                    offstyle={"primary"}
                                                    handlestyle={"success"}
                                                    style={{
                                                        textAlign: "center",
                                                        borderRadius: 5,
                                                    }}
                                                    active={this.state.speedSource === "OBD"}
                                                />
                                            </div>
                                        </div>
                                        <hr/>
                                        <div className={"row row-flex"}>
                                            <div className={"col-xs-1"} style={{marginTop: "auto", paddingRight: 0, textAlign: "left", marginBottom: 10}}>
                                                <Switch
                                                    onChange={this.handleSeatTimeSwitchChange}
                                                    checked={this.state.showSeatTime === 1}
                                                    height={17}
                                                    width={45}
                                                />
                                            </div>
                                            <div className={"col-xs-7"} style={{paddingLeft: 0}}>
                                                <div className={"App_bold_text App_black_text"}>
                                                    {this.props.t("seatTime")}
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.showSeatTime === 1 ? (
                                            <div className={"row row-flex w3-animate-fading"}>
                                                <div className={"col-xs-6"}>
                                                    <div className={"App_bold_text App_black_text text-right"} style={{lineHeight: "33px"}}>
                                                        {this.props.t("seatTimeLimitAlert")}
                                                    </div>
                                                </div>
                                                <div className={"col-xs-2"}>
                                                    <input
                                                        style={{borderWidth: "medium"}}
                                                        className={"form-control App_black_text"}
                                                        type={"number"}
                                                        value={this.state.seatTimeLimitAlert}
                                                        placeholder={this.props.t("enterValue")}
                                                        onChange={this.handleSeatTimeLimitChange}
                                                    />
                                                </div>
                                            </div>
                                        ) : null}
                                        <hr/>
                                        {this.state.gaugesConfig.map((gauge, i) => {
                                            return (
                                                <div key={"gauge_" + i}>
                                                    <div className={"row row-flex"} style={{marginBottom: 10}}>
                                                        {gauge.is_mandatory === 0 ? (
                                                            <div className={"col-xs-1"} style={{marginTop: "auto", paddingRight: 0, textAlign: "left"}}>
                                                                <Switch
                                                                    id={i + ""}
                                                                    onChange={this.handleActiveSwitchChange}
                                                                    checked={gauge.active === 1}
                                                                    height={17}
                                                                    width={45}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div className={"col-xs-offset-1"}/>
                                                        )}
                                                        <div className={"col-xs-7"} style={{paddingLeft: 0}}>
                                                            <div className={"App_bold_text App_black_text"}>
                                                                {gauge["full_name_" + this.props.cookies.get("lang")]} {gauge.unit.trim().length > 0 ? "(" + gauge.unit + ")" : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {gauge.active === 1 ? (
                                                        gauge.has_multiple_thresholds ? (
                                                            <div className={"w3-animate-fading"}>
                                                                <div className={"row row-flex"}>
                                                                    <div className={"col-xs-2"}>
                                                                        <input
                                                                            style={{borderColor: gauge.min_color, borderWidth: "medium"}}
                                                                            className={"form-control App_black_text"}
                                                                            type={"number"}
                                                                            value={gauge.min_value}
                                                                            placeholder={this.props.t("minValue")}
                                                                            onChange={(e) => {
                                                                                this.handleUpdateValue(e, i, "min_value");
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <ColorPickerButton
                                                                        updateColor={this.handleUpdateColor}
                                                                        initialColor={gauge.min_color !== null ? gauge.min_color : "#FFFFFF"}
                                                                        index={i}
                                                                        tag={"min_color"}
                                                                        marginLeft={2}
                                                                    />
                                                                    <div className={"col-xs-2"}>
                                                                        <input
                                                                            style={{borderColor: gauge.med_color, borderWidth: "medium"}}
                                                                            className={"form-control App_black_text"}
                                                                            type={"number"}
                                                                            value={gauge.med_value}
                                                                            placeholder={this.props.t("medValue")}
                                                                            onChange={(e) => {
                                                                                this.handleUpdateValue(e, i, "med_value");
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <ColorPickerButton
                                                                        updateColor={this.handleUpdateColor}
                                                                        initialColor={gauge.med_color !== null ? gauge.med_color : "#FFFFFF"}
                                                                        index={i}
                                                                        tag={"med_color"}
                                                                        marginLeft={35}
                                                                    />
                                                                    <div className={"col-xs-2"}>
                                                                        <input
                                                                            style={{borderColor: gauge.max_color, borderWidth: "medium"}}
                                                                            className={"form-control App_black_text"}
                                                                            type={"number"}
                                                                            value={gauge.max_value}
                                                                            placeholder={this.props.t("maxValue")}
                                                                            onChange={(e) => {
                                                                                this.handleUpdateValue(e, i, "max_value");
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <ColorPickerButton
                                                                        updateColor={this.handleUpdateColor}
                                                                        initialColor={gauge.max_color !== null ? gauge.max_color : "#FFFFFF"}
                                                                        index={i}
                                                                        tag={"max_color"}
                                                                        marginLeft={67}
                                                                    />
                                                                    {gauge.is_mandatory === 0 ? (
                                                                        <div className={"col-xs-2"} style={{marginTop: "auto"}}>
                                                                            <div className={"col-xs-6"} style={{padding: 0, textAlign: "left"}}>
                                                                                <label className={"App_black_text"}>{this.props.t("public").toUpperCase()}</label>
                                                                            </div>
                                                                            <div className={"col-xs-6"} style={{padding: 0, textAlign: "right", paddingTop: 3}}>
                                                                                <Switch
                                                                                    id={i + ""}
                                                                                    onChange={this.handlePublicSwitchChange}
                                                                                    checked={gauge.is_public === 1}
                                                                                    height={17}
                                                                                    width={45}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                                <hr/>
                                                            </div>
                                                        ) : (
                                                            <div className={"w3-animate-fading"}>
                                                                <div className={"row row-flex"}>
                                                                    <div className={"col-xs-3"}>
                                                                        <input
                                                                            style={{borderWidth: "medium"}}
                                                                            className={"form-control App_black_text"}
                                                                            type={"number"}
                                                                            value={gauge.max_value}
                                                                            placeholder={this.props.t("maxValue")}
                                                                            onChange={(e) => {
                                                                                this.handleUpdateValue(e, i, "max_value");
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <ColorPickerButton
                                                                        updateColor={this.handleUpdateColor}
                                                                        initialColor={gauge.max_color}
                                                                        index={i}
                                                                        tag={"max_color"}
                                                                        marginLeft={2}
                                                                    />
                                                                    {gauge.is_mandatory === 0 ? (
                                                                        <div className={"col-xs-2 row-flex"} style={{marginTop: "auto"}}>
                                                                            <div className={"col-xs-6"} style={{padding: 0, textAlign: "left"}}>
                                                                                <label className={"App_black_text"}>{this.props.t("public").toUpperCase()}</label>
                                                                            </div>
                                                                            <div className={"col-xs-6"} style={{padding: 0, textAlign: "right", paddingTop: 3}}>
                                                                                <Switch
                                                                                    id={i + ""}
                                                                                    onChange={this.handlePublicSwitchChange}
                                                                                    checked={gauge.is_public === 1}
                                                                                    height={17}
                                                                                    width={45}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                                <hr/>
                                                            </div>
                                                        )
                                                    ) : null}
                                                </div>
                                            );
                                        })}
                                    </>
                                ) : null}
                            </div>
                            <div className={"modal-footer"}>
                                {this.props.carID && (this.props.privileges.includes(super_admin) || this.props.isOwnTeam === 1) ? saveButton : null}
                                <button onClick={this.handleLogout} className={"btn App_white_text button"} style={{background: "#ed2126", color: "#FFFFFF"}}>{this.props.t("logout")}</button>
                                <button onClick={this.handleClose} className={"btn App_white_text button"} style={{background: "#ed2126", color: "#FFFFFF"}}>{this.props.t("close")}</button>
                            </div>
                        </Modal>
                    </>
                )
            )
        );
    }
}

class ColorPickerButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            displayColorPicker: false,
            buttonColor: this.props.initialColor
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleUpdateColor = this.handleUpdateColor.bind(this);
    }

    handleClick() {
        this.setState({displayColorPicker: !this.state.displayColorPicker});
    }

    handleClose() {
        this.setState({displayColorPicker: false});
    }

    handleColorChange(color, event) {
        this.setState({
            buttonColor: color.hex,
        });
    }

    handleUpdateColor(e) {
        this.props.updateColor(e, this.props.index, this.props.tag, this.state.buttonColor);
    }

    render() {
        const popover = {
            position: 'absolute',
            zIndex: '2',
            marginLeft: this.props.marginLeft + "%",
            marginTop: 50,
        };
        const cover = {
            position: 'fixed',
            top: '0px',
            right: '0px',
            bottom: '0px',
            left: '0px',
        };
        return (
            <>
                <div className={"col-xs-1"} style={{paddingLeft: 0, display: 'inline-block', cursor: 'pointer',}}>
                    <div
                        className={"form-control"}
                        onClick={this.handleClick}
                        style={{
                            float: "left",
                            border: "1px solid rgba(0, 0, 0, .2)",
                            background: this.state.buttonColor,
                        }}
                    />
                </div>
                {this.state.displayColorPicker ? (
                    <div style={popover}>
                        <div style={cover} onClick={this.handleClose}/>
                        <div className={"w3-animate-bottom"}>
                            <SketchPicker
                                color={this.state.buttonColor}
                                disableAlpha={true}
                                presetColors={[]}
                                width={260}
                                onChange={this.handleColorChange}
                                onChangeComplete={this.handleUpdateColor}
                            />
                        </div>
                    </div>
                ) : null}
            </>
        );
    }
}

export default withTranslation("translations")(withCookies(HeaderRow));
